





function getSearchParam(name) {
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
        return decodeURIComponent(name[1]);
}

function isStoredCampaignActive() {
  let storedCampaignStarts = localStorage.getItem("specialCampaignFrom");
  let storedCampaignEnds = localStorage.getItem("specialCampaignTo");
  const today = new Date().getTime();
  const storedCampaignIsActive = today >= storedCampaignStarts && today <= storedCampaignEnds;
  return storedCampaignIsActive;
}

let param = getSearchParam('utm_promo');
const campaignStarts = new Date('2024-12-01 00:00:00').getTime();
const campaignEnds = new Date('2024-12-17 09:00:00').getTime();

// set a new campaign + dates

if (param == '11DEC24.VPXMAS24') {
    console.error("new campaign detected");
    localStorage.setItem("specialCampaign", '11DEC24.VPXMAS24');
    localStorage.setItem("specialCampaignFrom", campaignStarts);
    localStorage.setItem("specialCampaignTo", campaignEnds);
}

// refresh stored dates just in case

let storedSpecialCampaign = localStorage.getItem("specialCampaign");
if (storedSpecialCampaign == '11DEC24.VPXMAS24') {
    console.error("campaign dates refreshed");
    localStorage.setItem("specialCampaignFrom", campaignStarts);
    localStorage.setItem("specialCampaignTo", campaignEnds);
}

// check if stored campaign is active
const storedCampaignIsActive = isStoredCampaignActive();
console.error("Special campaign: " + storedSpecialCampaign + ", active: " + storedCampaignIsActive);

// change the buttons if it proceeds

if (storedSpecialCampaign == '11DEC24.VPXMAS24' && storedCampaignIsActive == true) {
    let specialCheckoutButton = document.querySelector("#_special-checkout-button");
    if (specialCheckoutButton) {
        specialCheckoutButton.style.display = "block";
    }
  
    let specialRefreshButton = document.querySelector("#_special-refresh-button");
    if (specialRefreshButton) {
      specialRefreshButton.style.display = "block";  
    }
    
    let specialCartButton = document.querySelector("#_special-cart-button");
    if (specialCartButton) {
        specialCartButton.style.display = "block";
        let ordinaryCartButton = document.querySelector('a.underline mt-2');
        ordinaryCartButton.style.display = "none";
    }

    let ordinaryCheckoutButton = document.querySelector('button[name="checkout"]');
    if (ordinaryCheckoutButton) {
      ordinaryCheckoutButton.style.display = "none";  
    }
    
    let specialLabel = document.querySelector('#_special-collection-label');
    if (specialLabel) {
      specialLabel.style.display = "block";  
    }   

    
    document.querySelectorAll('._privatesale-discount').forEach(function(specialDiscountLabel, index, array) {
      if ( isStoredCampaignActive()) {
        specialDiscountLabel.style.display = "block";    
      }
    });


    // infinite scroll tags
    const config = { childList: true, subtree: true }; 
    
    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.classList && node.classList.contains('sf__col-item') && isStoredCampaignActive()) {
              node.querySelectorAll('._privatesale-discount').forEach(function(specialDiscountLabel, index, array) {
                specialDiscountLabel.style.display = "block";
              });
            }
          });
        };
      }
    }
    
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    
    // Start observing the target node for configured mutations
    observer.observe(document.body, config);
    
    }
